module.exports = __webpack_public_path__ + "static/media/barrel2.af95bf29.jpg";